import { graphql } from '@/gql';
import type { CreateFollowUpRequestInput } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const createFollowUpRequest = async (data: CreateFollowUpRequestInput) => {
  const response = await mutationExecute({
    variables: { data },
    mutation: graphql(`
      mutation CreateFollowUpRequest($data: CreateFollowUpRequestInput!) {
        createFollowUpRequest(data: $data) {
          id
          phoneNumber
          followUpAt
          serviceType
          callLogId
          callerId
          leadId
          notes
        }
      }
    `),
  });
  return response.data?.createFollowUpRequest ?? null;
};
